import { createMemoStyles } from '@wds/utils';
import { PricingAppTheme } from '~app/styles/pricing/types';

import { StyleProps } from '~app/pages/Pricing/components/DetailsTable/Categories/types';
import grow2529Theme from '../../theme/grow2529-theme';

export default createMemoStyles(({ spacing, palette, elevation, pricingPalette }: PricingAppTheme) => ({
  Highlighted: {
    backgroundColor: ({ packageName }: StyleProps) =>
      packageName ? grow2529Theme[packageName].primary : 'transparent',
    color: pricingPalette.colors.white,
    '& a': {
      color: pricingPalette.colors.white,
    },
  },
  Bullet: {
    borderRadius: '100%',
    backgroundColor: ({ packageName }: StyleProps) => (packageName ? grow2529Theme[packageName].primary : 'none'),
    width: 10,
    height: 10,
    display: 'block',
  },
}));
